module.exports = __webpack_public_path__ + "img/no_topic_tip.8da37b96.png";